import { GlobalContext } from "contexts/GlobalContext";
import { useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { RouteList } from "Routes";

export type PromptTag = {
    id: number;
    name: string;
    tagType: "tag" | "topic" | "program";
    tagId: number;
};

export const PromptSearch = () => {
    const { catchServerError, getPromptSearchTags } = useContext(GlobalContext);

    const history = useHistory();

    const [query, setQuery] = useState("");
    const [tags, setTags] = useState<Array<PromptTag>>([]);
    const [suggestions, setSuggestions] = useState<Array<PromptTag>>([]);

    useEffect(() => {
        let mounted = true;

        if (suggestions.length === 0) {
            getPromptSearchTags()
                .then(x => {
                    if (mounted) {
                        setSuggestions(x);
                    }
                })
                .catch(catchServerError);
        }

        return () => {
            mounted = false;
        };
    }, [catchServerError, getPromptSearchTags, suggestions]);

    // tags are the data source of the autocomplete
    useEffect(() => {
        if (suggestions && query.length >= 2) {
            const newTags = [...suggestions.filter(x => x.name.toLowerCase().indexOf(query.toLocaleLowerCase()) > -1)];

            if (newTags.length === 1 && newTags[0].name.toLowerCase() === query.toLowerCase()) {
                setTags([]);
            }

            setTags(newTags);
        } else {
            setTags([]);
        }
    }, [query, suggestions]);

    useEffect(() => {
        if (suggestions) {
            // get search string
            const urlParams = new URLSearchParams(window.location.search);

            const q = urlParams.get("q");

            if (q) {
                setQuery(q);
            }
        }
    }, [suggestions]);

    const search = useCallback(() => {
        const urlParams = new URLSearchParams();

        if (query) {
            urlParams.set("q", query);
        }

        history.push(`${RouteList.DiscoverSearch}?${urlParams.toString()}`);
    }, [history, query]);

    return (
        <form
            onSubmit={e => {
                e.preventDefault();
                search();
            }}
            className="input-group w-100"
        >
            <input
                type="search"
                list="search-datalist"
                className="form-control"
                placeholder="Search prompt library"
                value={query}
                onKeyDown={e => {
                    if (e.key === "Enter") {
                        search();
                    }
                }}
                onChange={e => setQuery(e.target.value)}
            />

            <datalist id="search-datalist">
                {tags.map(t => (
                    <option key={t.id}>{t.name}</option>
                ))}
            </datalist>

            <button className="btn btn-primary flex-grow-0">
                <span className="fas fa-search"></span>
            </button>
        </form>
    );
};
